import createDebug from 'debug';

const debug = createDebug('durable:runAbortablePromise');

export function runAbortablePromise<T = unknown>(
  promise: Promise<T>,
  abortSignal: AbortSignal,
): Promise<T> {
  const methodDebug = debug.extend('runAbortablePromise');
  methodDebug('Running promise that might abort');
  return new Promise((resolve, reject) => {
    if (abortSignal.aborted) {
      methodDebug('Promise aborted', abortSignal.reason);
      reject(abortSignal.reason);
      return;
    }

    const abortHandler = () => {
      methodDebug('Promise aborted', abortSignal.reason);
      reject(abortSignal.reason);
      abortSignal.removeEventListener('abort', abortHandler);
    };

    abortSignal.addEventListener('abort', abortHandler);

    promise
      .then((...args) => {
        methodDebug('Promise resolved', args);
        resolve(...args);
      })
      .catch((error) => {
        methodDebug('Promise rejected', error);
        reject(error);
      })
      .finally(() => {
        methodDebug('Promise finally; removing abort signal event handler');
        abortSignal.removeEventListener('abort', abortHandler);
      });
  });
}
